import { Navigate, Outlet } from 'react-router';
import { useConsultantAccess } from '../../hooks/consultant/use-consultant-access';
import { isGuardQuerySettling } from './guard-query-state';

/**
 * Gates the partner area (/consultant/partner) on the `isPartner` flag of
 * `GET /consultant/access`: the user must be Consulente or Owner of a tenant
 * with an active PartnerProfile — not necessarily the current one, so the
 * area stays reachable from a client workspace. Must render inside
 * ConsultantGuard (the route tree nests it there).
 */
export function PartnerGuard() {
  const { isPartner, isPending, fetchStatus } = useConsultantAccess();

  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }

  if (!isPartner) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
